import { initializeApp } from "firebase/app";
import { getMessaging, getToken, onMessage, isSupported } from "firebase/messaging";

const firebaseConfig = {
    apiKey: "AIzaSyCEEwa0XuHXr5f279N8kRVAdiVRAUFxgfc",
    authDomain: "gorevimizfcm.firebaseapp.com",
    projectId: "gorevimizfcm",
    storageBucket: "gorevimizfcm.firebasestorage.app",
    messagingSenderId: "588297460105",
    appId: "1:588297460105:web:b223a23beb4af3d8d4a958",
    measurementId: "G-BBLSBTNMKY"
};

const app = initializeApp(firebaseConfig);

// Kritik Değişiklik: messaging nesnesini doğrudan başlatmak yerine null yapıyoruz
let messaging = null;

// Messaging servisini asenkron ve güvenli şekilde başlatan yardımcı fonksiyon
const initializeMessaging = async () => {
    if (messaging) return messaging;
    try {
        const supported = await isSupported();
        if (supported) {
            messaging = getMessaging(app);
            return messaging;
        }
    } catch (err) {
        console.warn("FCM desteklenmiyor:", err);
    }
    return null;
};

export const requestForToken = async () => {
    try {
        const msg = await initializeMessaging();
        if (!msg) return null; // Destek yoksa sessizce çık

        const currentToken = await getToken(msg, {
            vapidKey: 'BB2Eg-j8MS520cyb-Rlq11YF1Mg2FtYqRjcn43Q-ubj-HvIWp3Ekl5sh56rlEeauWmqciel8o6kNsrJpmxnso6g'
        });
        if (currentToken) {
            console.log('FCM Token:', currentToken);
            return currentToken;
        }
    } catch (err) {
        console.log('Token alınırken hata oluştu:', err);
    }
};

export const onMessageListener = async () => {
    const msg = await initializeMessaging();
    if (!msg) return new Promise(() => { }); // Destek yoksa asla resolve olmayan bir promise dön

    return new Promise((resolve) => {
        onMessage(msg, (payload) => {
            resolve(payload);
        });
    });
};